export default "__VITE_ASSET__BsJ19V8s__"